import React from 'react';
import { ToastContainer } from 'react-toastify';

import HomeRoutes from './components/Routes/HomeRoutes';

const App = () => {
  return (
    <>
      <HomeRoutes />
      <ToastContainer position="top-right" autoClose={4000} />
    </>
  );
};

export default App;
